import { FetchError, TierInfo } from "@decibeltrade/sdk";
import { type FetchQueryOptions, useQuery } from "@tanstack/react-query";

import { readDexSdk } from "../dex-sdk";

export interface TierInfoQueryArgs {
  ownerAddr: string | undefined;
}

export function tierInfoQueryKey({ ownerAddr }: TierInfoQueryArgs) {
  return ["tierInfo", ownerAddr] as const;
}

export const PLACEHOLDER_TIER_INFO: TierInfo = {
  owner: "",
  total_amps: 0,
  rank: null,
  current_tier: null,
  tiers: [
    { name: "gold", hz_threshold: 0, progress: 0 },
    { name: "doublePlatinum", hz_threshold: 0, progress: 0 },
    { name: "diamond", hz_threshold: 0, progress: 0 },
  ],
};

export function tierInfoQuery({ ownerAddr }: TierInfoQueryArgs) {
  return {
    queryKey: tierInfoQueryKey({ ownerAddr }),
    queryFn: async () => {
      if (!ownerAddr) return PLACEHOLDER_TIER_INFO;

      try {
        return await readDexSdk.tier.getByOwner({ ownerAddr });
      } catch (error) {
        if (error instanceof FetchError && error.status === 404) {
          return PLACEHOLDER_TIER_INFO;
        }
        throw error;
      }
    },
    retry(failureCount: number, error: Error) {
      if (error instanceof FetchError && error.status === 404) {
        return false;
      }
      return failureCount < 3;
    },
  } satisfies FetchQueryOptions<TierInfo>;
}

export function useTierInfoQuery(args: TierInfoQueryArgs) {
  return useQuery({
    ...tierInfoQuery(args),
    enabled: !!args.ownerAddr,
  });
}
